
import { ILaunchViewModel } from "../../components/launch/interface";
import { IConfigAssets } from "../../interface/config";
import defaultProps from "./defaultProps";
import { ILaunchEvent, ILaunchState, IStateProcessor, IStateProcessorLaunchState } from "./state/events";

function mapping(downloadClick: () => void, skipClick: () => void, assets: IConfigAssets, processor: IStateProcessor<ILaunchState, ILaunchEvent, IStateProcessorLaunchState>): ILaunchViewModel {
    let model: ILaunchViewModel = defaultProps();

    model.downloadButton.onClick = downloadClick;
    model.skipButton.onClick = skipClick;

    model.status = {
        text: '',
        fontFamily: 'Gill Sans',
        fontSize: '8vmin',
        fontAlignment: 'center',
        fontWeight: 300,
        color: '#000',
        visible: true,
    }

    model.detail = {
        text: '',
        fontFamily: 'Gill Sans',
        fontSize: '3vmin',
        fontAlignment: 'center',
        fontWeight: 300,
        color: '#000',
        visible: false,
    }

    switch ( processor.status() ) {
        default:
        case ILaunchState.Initializing:
            model.progressBar.visible = false;
            model.status.text = "...Loading";
            break;

        case ILaunchState.UpdatingSite:
            model.progressBar.visible = true;
            model.progressBar.progress = processor.state().updateSiteProgress ?? 0;
            model.status.text = "...Updating";
            break;

        case ILaunchState.AwaitingUserDownloadSkipConfirmation:
            model.progressBar.visible = false;
            model.progressBar.progress = processor.state().updateSiteProgress ?? 0;
            model.status.text = "Download all content now?";
            break;

        case ILaunchState.DownloadingMedia:
            model.progressBar.visible = true;
            model.progressBar.progress = processor.state().downloadMediaProgress ?? 0;
            model.status.text = "...Downloading";
            break;

        case ILaunchState.Halted:
            model.progressBar.visible = false;
            model.status.text = '...Please refresh page';
            model.detail.text = processor.error() ?? '';
            model.detail.visible = true;
            break;
    }

    const showingUserDialog = processor.status() === ILaunchState.AwaitingUserDownloadSkipConfirmation;

    model.downloadButton.visible = showingUserDialog;
    model.skipButton.visible = showingUserDialog;

    model.backgroundColor = assets.pwa.backgroundColor;
    model.status.color = assets.pwa.themeColor;
    model.centerImage.url = assets.pwa.images.icon512;

    model.status.visible = true;

    return model;
}

export default mapping

